/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Send_Invites_HintInputs */

const cs_ebr_send_invites_hint = /** @type {(inputs: Ebr_Send_Invites_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vypnuto: účty vzniknou bez e-mailu, pozvánku pošlete později z Uživatelů.`)
};

const en_ebr_send_invites_hint = /** @type {(inputs: Ebr_Send_Invites_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Off: accounts are created without e-mail; send invites later from Users.`)
};

/**
* | output |
* | --- |
* | "Off: accounts are created without e-mail; send invites later from Users." |
*
* @param {Ebr_Send_Invites_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_send_invites_hint = /** @type {((inputs?: Ebr_Send_Invites_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Send_Invites_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_send_invites_hint(inputs)
	return cs_ebr_send_invites_hint(inputs)
});